// Object expect Array
export function isObject(val: any) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

export function isDate(time: any) {
  return time instanceof Date;
}

/**
 * 格式化时间
 * @param {Date} time 
 * @param {*} format eg: YYYY-MM-DD HH:mm:ss
 */
export function formatTime (time: Date, format: string) {

  if (!isDate(time)) {
    // TODO 假定传入数据不是Date就是时间戳
    time = new Date(time);
  }

  const year = time.getFullYear()
  const month = ('00' + (time.getMonth() + 1)).slice(-2)
  const day = ('00' + time.getDate()).slice(-2)
  const hour = ('00' + time.getHours()).slice(-2)
  const min = ('00' + time.getMinutes()).slice(-2)
  const sec = ('00' + time.getSeconds()).slice(-2)
  //@ts-ignore
  return format.replace('YYYY', year)
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hour)
      .replace('mm', min)
      .replace('ss', sec)
}

/**
 * 裁图
 * @param {*} imageUrl 
 * @param {*} WH widthxheight eg: 120x120
 */
export function cropImage(imageUrl: string, width = '', height = '') {
  // Doc: https://cloud.tencent.com/document/api/460/6929
  if (!width || !height) {
    return imageUrl;
  }
  return `${imageUrl}?imageView2/5/w/${width}/h/${height}`;
}

/**
 * 解析url参数
 * @param {String} name 参数名
 * @return {String} 值
 */
export const getValueFromLocationSearch = (name: string) => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return window.decodeURI(r[2]);

  return null;
}
